export const DEFAULT_TURNSTILE_SITE_KEY = '0x4AAAAAADt5_iewCpcg6-Iz'
export const LOCAL_DEVELOPMENT_TURNSTILE_SITE_KEY = '1x00000000000000000000BB'
export const LOCAL_DEVELOPMENT_TURNSTILE_TOKEN = 'XXXX.DUMMY.TOKEN.XXXX'

interface TurnstileSiteKeyEnv {
  NEXT_PUBLIC_ENV?: string
  NEXT_PUBLIC_TURNSTILE_SITE_KEY?: string
  VITE_PUBLIC_ENV?: string
  VITE_TURNSTILE_SITE_KEY?: string
}

interface TurnstileSiteKeyOptions {
  env?: TurnstileSiteKeyEnv
}

export function getTurnstileSiteKey({ env = getDefaultEnv() }: TurnstileSiteKeyOptions = {}) {
  if (isNonProductionEnvironment(env)) {
    return LOCAL_DEVELOPMENT_TURNSTILE_SITE_KEY
  }

  return (
    env.NEXT_PUBLIC_TURNSTILE_SITE_KEY || env.VITE_TURNSTILE_SITE_KEY || DEFAULT_TURNSTILE_SITE_KEY
  )
}

export function shouldSendTurnstileTokenHeader(token: string) {
  return token.length > 0
}

function getDefaultEnv(): TurnstileSiteKeyEnv {
  if (typeof process === 'undefined') {
    return {}
  }

  return {
    NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
    NEXT_PUBLIC_TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY,
    VITE_PUBLIC_ENV: process.env.VITE_PUBLIC_ENV,
    VITE_TURNSTILE_SITE_KEY: process.env.VITE_TURNSTILE_SITE_KEY,
  }
}

function isNonProductionEnvironment(env: TurnstileSiteKeyEnv) {
  return (env.NEXT_PUBLIC_ENV ?? env.VITE_PUBLIC_ENV) !== 'production'
}
